/* eslint-disable */
import '../../components/buttons/mainBtn.css';
import { useTranslation } from 'react-i18next';
import ErrorPage from '../errorPage/ErrorPage';
import Spinner from '../../components/loaders/globalSpinner/Spinner';
import { api, useGetBloodyLitersSavedQuery } from '../../redux/api';
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getGeolocationWithPermission } from '../../hookServices/getGeolocationWithPermission';
import { ENV } from '../../environment';
import './HomePage.css';
import '../b2bPage/b2bPage.css';
import SVGBanner from '../../components/svgComponents/SVGBanner';
import { getCookie } from '../../hookServices/cookiesManager';
import { useLocalStorage } from '../../hookServices/useLocalStorage';
import Map from './Map';
import { SeoHead } from '../../components/SeoHead';
import { filterEvuaPortsForMap, isEvuaExclusiveMapMode, MAP_FILTER_160_KW } from './evuaMapFilters';
import { filterKm220PortsForMap, km220AcdcForMapFilters } from './km220MapFilters';
import { buildMapFilterParam, parseMapFilterParam, withMapFilterSearchParams } from './mapFilterUrl';
import {
  EMS_SEO_DESCRIPTION_UK,
  EMS_SEO_KEYWORDS_UK,
  EMS_OPEN_EMS_STRUCTURED_DESCRIPTION,
} from '../../seo/emsSeoContent';

// SEO configuration for homepage - EV charging discovery + affordable-tariff intent (neutral claims)
const seoConfig = {
  title: 'Де зарядити авто в Україні | Мапа доступних зарядок — Мережа 220 км',
  description:
    'Де зарядити авто та знайти доступні тарифи на зарядку: мапа всіх швидких зарядних станцій мережі 220 км. Порівняйте ціни в грн/кВт·г, увімкніть фільтр найдешевших станцій, дізнайтесь які працюють при блекауті. Type2, CCS2, CHAdeMO, GBT. Альтернатива Toka, Ecofactor, Go2You. ' +
    EMS_SEO_DESCRIPTION_UK +
    ' github.com/220-organization/open-ems. Реальні дані 220-km.com досліджені в ІЕД НАН України: динамічне ціноутворення на ЕЗС, керування попитом, балансування ОЕС (порт 2005, Південноукраїнськ, 2025).',
  keywords: [
    // Brand keywords
    'мережа 220 км',
    'мережа 220',
    '220-km',
    '220 км',
    // Affordable charging intent (neutral — find accessible tariffs, not "cheapest guarantee")
    'дешеві зарядки',
    'дешеві зарядні станції',
    'де зарядити авто',
    'дешево зарядитись',
    'доступні тарифи зарядка',
    'найдешевші зарядні станції',
    'ціна зарядки електромобіля',
    'де зарядити електромобіль дешево',
    // Competitor keywords - Ukrainian
    'тока зарядка',
    'тока зарядні станції',
    'toka зарядка',
    'toka charging',
    'екофактор',
    'ecofactor',
    'екофактор зарядка',
    'ecofactor зарядні станції',
    'готую',
    'go2you',
    'go to you',
    'готую зарядка',
    'go2you charging',
    // Alternative keywords
    'альтернатива toka',
    'альтернатива екофактор',
    'альтернатива go2you',
    'замість toka',
    'замість екофактор',
    'краще ніж toka',
    // General EV charging keywords - Ukrainian
    'зарядні станції для електромобілів',
    'зарядка електромобіля',
    'де зарядити електромобіль',
    'зарядні станції Україна',
    'зарядка електромобіля Україна',
    'швидка зарядка електромобіля',
    'AC DC зарядка',
    'електрозаправка',
    'зарядка EV',
    'EV charging Ukraine',
    // City keywords - all major Ukrainian cities
    'Київ зарядка',
    'Харків зарядка',
    'Одеса зарядка',
    'Дніпро зарядка',
    'Львів зарядка',
    'Запоріжжя зарядка',
    'Кривий Ріг зарядка',
    'Миколаїв зарядка',
    'Вінниця зарядка',
    'Полтава зарядка',
    'Чернігів зарядка',
    'Черкаси зарядка',
    'Житомир зарядка',
    'Суми зарядка',
    'Хмельницький зарядка',
    'Чернівці зарядка',
    'Рівне зарядка',
    'Івано-Франківськ зарядка',
    'Тернопіль зарядка',
    'Луцьк зарядка',
    'Ужгород зарядка',
    'Кропивницький зарядка',
    'Умань зарядка',
    'Біла Церква зарядка',
    'Бровари зарядка',
    'Ірпінь зарядка',
    'Буча зарядка',
    'Бориспіль зарядка',
    'Фастів зарядка',
    'Кременчук зарядка',
    'Павлоград зарядка',
    'Нікополь зарядка',
    'Камянське зарядка',
    'Мелітополь зарядка',
    'Бердянськ зарядка',
    'Енергодар зарядка',
    'Славутич зарядка',
    'Коростень зарядка',
    'Новоград-Волинський зарядка',
    'Коломия зарядка',
    'Стрий зарядка',
    'Мукачево зарядка',
    'Трускавець зарядка',
    'Моршин зарядка',
    'Яремче зарядка',
    'Буковель зарядка',
    'Славське зарядка',
    'Затока зарядка',
    'Коблево зарядка',
    'зарядні станції Київ',
    'зарядні станції Харків',
    'зарядні станції Одеса',
    'зарядні станції Львів',
    'зарядні станції Дніпро',
    'зарядні станції Умань',
    // Highway/Road keywords - major routes in Ukraine
    'зарядка на трасі Київ Одеса',
    'зарядка на трасі Київ-Одеса',
    'зарядка М05',
    'зарядка на трасі Київ Харків',
    'зарядка на трасі Київ-Харків',
    'зарядка М03',
    'зарядка на трасі Київ Львів',
    'зарядка на трасі Київ-Львів',
    'зарядка М06',
    'зарядка на трасі Київ Чоп',
    'зарядка на трасі Київ-Чоп',
    'зарядка на трасі Одеса Київ',
    'зарядка на трасі Харків Київ',
    'зарядка на трасі Львів Київ',
    'зарядка на трасі Дніпро Київ',
    'зарядка на трасі Київ Житомир',
    'зарядка на трасі Київ-Житомир',
    'зарядка на трасі Київ Чернігів',
    'зарядка на трасі Київ-Чернігів',
    'зарядка на трасі Київ Полтава',
    'зарядка на трасі Київ-Полтава',
    'зарядка на трасі Харків Дніпро',
    'зарядка на трасі Харків-Дніпро',
    'зарядка на трасі Дніпро Запоріжжя',
    'зарядка на трасі Дніпро-Запоріжжя',
    'зарядка на трасі Одеса Миколаїв',
    'зарядка на трасі Одеса-Миколаїв',
    'зарядка на трасі Львів Ужгород',
    'зарядка на трасі Львів-Ужгород',
    'зарядка на трасі Львів Краківець',
    'зарядка на трасі Львів-Краківець',
    'зарядка на трасі Київ Умань',
    'зарядка на трасі Київ-Умань',
    'зарядка на трасі Вінниця Умань',
    'зарядка на трасі Умань Одеса',
    'зарядка на трасі Е40',
    'зарядка на трасі Е95',
    'зарядка на трасі Е50',
    'зарядка на трасі М01',
    'зарядка на трасі М04',
    'зарядка на трасі М07',
    'зарядка на автобані',
    'зарядна станція на трасі',
    'де зарядити на трасі',
    // Action keywords
    'знайти зарядну станцію',
    'карта зарядних станцій',
    'найближча зарядка',
    'безкоштовна зарядка електромобіля',
    'ціни на зарядку електромобіля',
    // App keywords
    'додаток для зарядки електромобіля',
    'мобільний додаток зарядка',
    'QR зарядка',
    // All EV charging operators in Ukraine (competitor targeting)
    'ECOFACTOR зарядка',
    'Toka зарядка',
    'GO TO-U зарядка',
    'Flash зарядка',
    'Yasno зарядка',
    'EVA зарядка',
    'EVA Chargers',
    'QuickPower зарядка',
    'UGV зарядка',
    'Ladergy зарядка',
    'CloudPay зарядка',
    'Chargex зарядка',
    'ICar зарядка',
    'EVBOOST',
    'evboost',
    // Connector types keywords
    'Type2 зарядка',
    'Type1 зарядка',
    'CHAdeMO зарядка',
    'CCS2 зарядка',
    'CCS1 зарядка',
    'GBT зарядка',
    'GBT DC',
    'NACS зарядка',
    'Tesla зарядка',
    'Type2 станції',
    'CHAdeMO станції',
    'CCS зарядні станції',
    // Car origin keywords (like EVBOOST)
    'зарядка для автомобілів з Європи',
    'зарядка для автомобілів з Китаю',
    'зарядка для автомобілів з Америки',
    'зарядка для автомобілів з Японії',
    'зарядка китайського електромобіля',
    'зарядка BYD',
    'зарядка NIO',
    'зарядка Tesla',
    'зарядка Volkswagen ID',
    'зарядка Hyundai Ioniq',
    'зарядка Kia EV6',
    'зарядка Nissan Leaf',
    'зарядка Renault Zoe',
    // Power keywords
    'швидка зарядка 50 кВт',
    'швидка зарядка 100 кВт',
    'швидка зарядка 150 кВт',
    'швидка зарядка 350 кВт',
    'суперчарджер',
    'supercharger Ukraine',
    // Blackout/Power outage keywords - VERY IMPORTANT for Ukraine
    'зарядка при відключенні світла',
    'зарядка в блекаут',
    'зарядка без світла',
    'зарядні станції які працюють при відключенні світла',
    'де є світло зарядка',
    'зарядка коли немає світла',
    'зарядні станції з генератором',
    'автономні зарядні станції',
    'зарядка при блекауті',
    'зарядка під час блекауту',
    'зарядні станції з резервним живленням',
    'зарядка електромобіля без світла',
    'де зарядити коли відключили світло',
    'зарядні станції з автономним живленням',
    'зарядка при віключенні електрики',
    'де точно є світло',
    'зарядні станції онлайн при блекауті',
    'зарядка EV блекаут',
    'станції що працюють без світла',
    'зарядка при відсутності електрики',
    // Russian blackout keywords
    'зарядка при отключении света',
    'зарядка в блэкаут',
    'зарядка без света',
    'зарядные станции с генератором',
    'где есть свет зарядка',
    'зарядка когда нет света',
    'автономные зарядные станции',
    // Feature keywords (like EVBOOST)
    'мапа зарядних станцій',
    'карта зарядок',
    'планувальник маршрутів EV',
    'роумінг зарядних станцій',
    'безкоштовна зарядка',
    'ціна зарядки кВт',
    // Russian keywords for broader reach
    'зарядка электромобиля Украина',
    'зарядные станции Украина',
    'тока зарядка',
    'экофактор',
    'готуйо',
    'сеть зарядных станций',
    'зарядка на трассе Киев Одесса',
    'зарядка на трассе Киев Харьков',
    'Умань зарядка',
    'Киев зарядка',
    'Харьков зарядка',
    'Одесса зарядка',
    'Type2 зарядка',
    'CCS2 зарядка',
    'CHAdeMO зарядка',
    // Open EMS & energy stack (220-km ecosystem)
    'Open EMS',
    'open-ems',
    'EMS Ukraine',
    'система керування енергією',
    'енергоменеджмент',
    'VPP',
    'OREE DAM',
    'Deye inverter',
    'smart charging EMS',
    'peak shaving battery',
    'B2B EV charging API',
    'Energy Management System',
    // IED NAS Ukraine — dynamic tariffs & demand response (real 220-km.com data)
    'УДК 621.316',
    'ІЕД НАН України',
    'Інститут електродинаміки НАН України',
    'динамічне ціноутворення зарядка',
    'сонячний тариф EV',
    'керування попитом зарядні станції',
    'балансування ОЕС',
    'ОЕС України',
    'Південноукраїнськ зарядка',
    'зарядна станція 2005',
    'Demand Response Ukraine',
    'grid balancing EV charging',
    // GridLab-inspired EMS / microgrid keywords (https://gridlab.com.ua/uk)
    ...EMS_SEO_KEYWORDS_UK.split(', '),
  ].join(', '),
  url: 'https://220-km.com',
  image: 'https://220-km.com/logo512.png',
  structuredData: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://220-km.com/#organization',
    name: 'Мережа 220 км',
    alternateName: ['мережа 220', '220-km', 'Мережа 220', '220 км', 'мережа зарядних станцій 220'],
    legalName: 'ТОВАРИСТВО З ОБМЕЖЕНОЮ ВІДПОВІДАЛЬНІСТЮ «роумінгова мережа зарядних станцій 220 км»',
    url: 'https://220-km.com',
    logo: 'https://220-km.com/logo512.png',
    image: 'https://220-km.com/logo512.png',
    description:
      'Мережа 220 км - найбільша роумінгова мережа зарядних станцій для електромобілів в Україні. Альтернатива Toka, Ecofactor, Go2You. Розробляє Open EMS — open-source EMS для сонячної генерації, батареї та зарядки EV з інтеграцією мережі 220-km. Платформа з реальними даними зарядки цитована в дослідженні ІЕД НАН України про динамічні тарифи та керування попитом на ЕЗС в ОЕС.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'проспект Соборності, будинок 17 офіс 2-92',
      addressLocality: 'Київ',
      postalCode: '02160',
      addressCountry: 'UA',
    },
    taxID: '45977567',
    areaServed: {
      '@type': 'Country',
      name: 'Ukraine',
    },
    knowsAbout: [
      'Electric vehicle charging',
      'EV charging stations',
      'Зарядка електромобілів',
      'AC charging',
      'DC fast charging',
      'Open EMS',
      'Energy management system',
      'Day-ahead market DAM',
      'Smart charging',
      'Battery storage optimization',
      'Dynamic electricity pricing',
      'Demand response',
      'Unified Power System of Ukraine',
      'Renewable energy integration',
      'Microgrid EMS',
      'BESS monitoring',
      'Electricity arbitrage DAM IDM',
      'ML solar generation forecast',
      'Island mode energy system',
      'Modbus MQTT OPC UA',
    ],
    sameAs: ['https://www.facebook.com/220km.network', 'https://t.me/network220'],
  },
  websiteStructuredData: {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': 'https://220-km.com/#website',
    url: 'https://220-km.com',
    name: 'Мережа 220 км - Зарядні станції для електромобілів',
    alternateName: ['мережа 220', '220-km', 'Зарядні станції 220'],
    description:
      'Роумінгова мережа зарядних станцій для електромобілів в Україні. Альтернатива Toka, Ecofactor, Go2You. Open EMS — self-hosted EMS для DER, DAM та EV. Дані платформи використані в науковому аналізі ІЕД НАН України щодо динамічних тарифів на ЕЗС.',
    publisher: {
      '@id': 'https://220-km.com/#organization',
    },
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://220-km.com/list?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  // Structured data for EV Charging service
  serviceStructuredData: {
    '@context': 'https://schema.org',
    '@type': 'Service',
    '@id': 'https://220-km.com/#service',
    name: 'Зарядка електромобілів',
    alternateName: ['EV Charging', 'Electric Vehicle Charging', 'Зарядні станції'],
    description:
      'Послуги зарядки електромобілів на станціях мережі 220 км по всій Україні. Мапа з цінами в грн/кВт·г і фільтром доступніших тарифів допомагає знайти, де зарядити авто. AC та DC зарядка. Альтернатива Toka, Ecofactor, Go2You. Для операторів доступні B2B інструменти та Open EMS для енергетичного стеку сонце + батарея + EV. Динамічні тарифи та профілі навантаження — об’єкт досліджень ІЕД НАН України на реальних даних мережі.',
    provider: {
      '@id': 'https://220-km.com/#organization',
    },
    areaServed: {
      '@type': 'Country',
      name: 'Ukraine',
    },
    serviceType: 'Electric Vehicle Charging',
    category: 'Automotive Services',
  },
  faqStructuredData: {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': 'https://220-km.com/#faq',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Де зарядити авто або електромобіль в Україні?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'На мапі 220-km.com показані всі швидкі зарядні станції по всій Україні. Відкрийте https://220-km.com/, знайдіть найближчу станцію з Type2, CCS2, CHAdeMO або GBT і запустіть зарядку через QR або веб-додаток.',
        },
      },
      {
        '@type': 'Question',
        name: 'Як знайти доступну ціну на зарядку або дешево зарядитись?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'На мапі 220-km.com відображаються тарифи в грн/кВт·г. Увімкніть фільтр найдешевших станцій, щоб порівняти доступні тарифи поруч і обрати станцію з підходящою ціною. Окремі станції також мають динамічні або сонячні тарифи.',
        },
      },
      {
        '@type': 'Question',
        name: 'Що таке динамічний або сонячний тариф на зарядних станціях?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Динамічний тариф змінюється протягом доби залежно від умов мережі або генерації. За даними дослідження ІЕД НАН України на реальних сесіях 220-km.com (порт 2005, Південноукраїнськ, 2025) сонячний тариф удень знижувався до 2,2 грн/кВт·г порівняно з базовою ціною близько 16 грн/кВт·г.',
        },
      },
      {
        '@type': 'Question',
        name: 'Які зарядні станції працюють при блекауті або відключенні світла?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'На мапі 220-km.com видно онлайн-статус станцій у реальному часі. Фільтр онлайн допомагає знайти станції, які працюють під час відключень світла, зокрема з резервним або автономним живленням.',
        },
      },
    ],
  },
  openEmsSoftwareStructuredData: {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    '@id': 'https://220-km.com/#open-ems',
    name: 'Open EMS',
    alternateName: ['open-ems', '220-km Open EMS'],
    applicationCategory: 'EnergyManagementApplication',
    operatingSystem: 'Docker, Linux',
    description: EMS_OPEN_EMS_STRUCTURED_DESCRIPTION,
    url: 'https://github.com/220-organization/open-ems',
    codeRepository: 'https://github.com/220-organization/open-ems',
    license: 'https://www.gnu.org/licenses/gpl-3.0.html',
    isAccessibleForFree: true,
    publisher: {
      '@id': 'https://220-km.com/#organization',
    },
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
  },
  iedNasResearchArticleStructuredData: {
    '@context': 'https://schema.org',
    '@type': 'ScholarlyArticle',
    '@id': 'https://220-km.com/#research-ied-dynamic-tariffs-ev-2025',
    identifier: {
      '@type': 'PropertyValue',
      propertyID: 'UDC',
      value: '621.316:681.3',
    },
    headline: 'Вплив тарифу на профіль навантаження зарядних станцій електромобілів: аналіз реальних даних',
    alternativeHeadline: 'Tariff impact on EV charging station load profile: analysis of real data',
    inLanguage: ['uk', 'en'],
    abstract:
      "Impact of dynamic pricing on commercial EV charging load profiles in Ukraine's Unified Power System. Field experiment Jul–Sep 2025 at a 7 kW Type 2 AC port (220-km.com, port 2005, Pivdennoukrainsk): solar tariff vs base UAH 16/kWh, down to UAH 2.2/kWh midday; ~5× consumption growth and stable user patterns; scaling potential for grid balancing discussed.",
    keywords:
      'Unified Power System of Ukraine, dynamic pricing, EV charging stations, demand management, grid balancing, renewable energy sources, 220-km.com',
    author: [
      { '@type': 'Person', name: 'V.V. Sychova', sameAs: 'https://orcid.org/0000-0001-7385-1680' },
      { '@type': 'Person', name: 'V.O. Miroshnyk', sameAs: 'https://orcid.org/0000-0001-9036-7268' },
    ],
    affiliation: {
      '@type': 'Organization',
      name: 'Institute of Electrodynamics of the National Academy of Sciences of Ukraine',
      alternateName: 'Інститут електродинаміки НАН України',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '56 Beresteiskyi Ave.',
        addressLocality: 'Kyiv',
        postalCode: '03057',
        addressCountry: 'UA',
      },
    },
    datePublished: '2026-03-15',
    dateModified: '2026-03-22',
    mentions: [
      { '@type': 'WebApplication', name: '220-km.com', url: 'https://220-km.com' },
      {
        '@type': 'WebPage',
        name: 'EV charging start flow (station 2005)',
        url: 'https://220-km.com/start?station=2005',
        description:
          'Experimental AC charging sessions on the 220-km.com platform as described in the IED NAS Ukraine study.',
      },
    ],
    isBasedOn: {
      '@type': 'Dataset',
      name: '220-km.com / evboost.com.ua EV energy analytics (cited in study)',
      description: 'Analytical platforms referenced for aggregate EV consumption in Ukraine.',
    },
  },
};

export default function HomeMapPage({ fingerPrint }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const mapFilterFromUrl = searchParams.get('mapFilter');
  const urlMapFilters = useMemo(() => parseMapFilterParam(mapFilterFromUrl), [mapFilterFromUrl]);
  // Two independent filters: port type (all/fast/slow) and car type (all/china/european)
  const [portFilter, setPortFilter] = useState(() => urlMapFilters?.portFilter ?? 'all');
  const [carFilter, setCarFilter] = useLocalStorage('carFilter', urlMapFilters?.carFilter ?? 'all');
  const [onlineFilter, setOnlineFilter] = useState(() => urlMapFilters?.onlineFilter ?? false);
  // New users (no localStorage yet): roaming on by default. URL / saved preference still win.
  const [filter80Kw, setFilter80Kw] = useLocalStorage('mapFilter80Kw', urlMapFilters?.filter80Kw ?? true);
  const [nacsFilter, setNacsFilter] = useState(() => Boolean(urlMapFilters?.nacsFilter));
  const [filter160Kw, setFilter160Kw] = useLocalStorage(
    'mapFilter160Kw',
    Boolean(urlMapFilters?.filter80Kw && urlMapFilters?.filter160Kw)
  );
  const filter160KwActive = Boolean(filter80Kw && filter160Kw);
  const [cheapestFilter, setCheapestFilter] = useLocalStorage(
    'mapFilterCheapest',
    urlMapFilters?.cheapestFilter ?? false
  );
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  /** Skip one URL→state apply after we ourselves updated `mapFilter` (avoids echo). */
  const skipNextUrlApplyRef = useRef(false);

  // Local: once on mount, turn roaming on if LS still has the old default false (URL wins).
  useLayoutEffect(() => {
    if (ENV !== 'local' || mapFilterFromUrl) return;
    setFilter80Kw(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getApiParams(nextPortFilter = portFilter, next80Kw = filter80Kw, next160KwActive = filter160KwActive) {
    const acdc = km220AcdcForMapFilters({
      filter80Kw: next80Kw,
      filter160KwActive: next160KwActive,
      portFilter: nextPortFilter,
    });
    const chinaFilter = carFilter === 'all' ? 'all' : carFilter === 'china' ? 'china' : 'not_china';
    return { acdc, chinaFilter, freshOnly: onlineFilter };
  }

  async function applyMapFilter(clickedButton) {
    if (clickedButton === '80kw') {
      const new80Kw = !filter80Kw;
      const new160Kw = new80Kw ? filter160Kw : false;
      const nextNacs = new80Kw ? nacsFilter : false;
      const next160KwActive = Boolean(new80Kw && new160Kw);
      setFilter80Kw(new80Kw);
      if (!new80Kw) {
        setFilter160Kw(false);
        setNacsFilter(false);
      }
      syncMapFiltersToUrl({
        filter80Kw: new80Kw,
        filter160Kw: new160Kw,
        cheapestFilter,
        carFilter,
        portFilter,
        onlineFilter,
        nacsFilter: nextNacs,
      });
      setIsFilterLoading(true);
      try {
        const { acdc, chinaFilter: china, freshOnly } = getApiParams(portFilter, new80Kw, next160KwActive);
        if (new80Kw) {
          await Promise.all([ensureEvuaStationsLoaded(), fetchKm220Ports(acdc, freshOnly, china)]);
        } else {
          await Promise.all([fetchTokaPorts(acdc, freshOnly, china), fetchKm220Ports(acdc, freshOnly, china)]);
        }
      } finally {
        setIsFilterLoading(false);
      }
      return;
    }
    if (clickedButton === '160kw') {
      if (!filter80Kw) return;
      const new160Kw = !filter160Kw;
      setFilter160Kw(new160Kw);
      syncMapFiltersToUrl({
        filter80Kw: true,
        filter160Kw: new160Kw,
        cheapestFilter,
        carFilter,
        portFilter,
        onlineFilter,
        nacsFilter,
      });
      const { acdc, chinaFilter: china, freshOnly } = getApiParams(portFilter, true, Boolean(new160Kw));
      await Promise.all([ensureEvuaStationsLoaded(), fetchKm220Ports(acdc, freshOnly, china)]);
      return;
    }
    if (clickedButton === 'cheapest') {
      const newCheapest = !cheapestFilter;
      setCheapestFilter(newCheapest);
      syncMapFiltersToUrl({
        filter80Kw,
        filter160Kw,
        cheapestFilter: newCheapest,
        carFilter,
        portFilter,
        onlineFilter,
        nacsFilter,
      });
      if (newCheapest && filter80Kw) {
        await ensureEvuaStationsLoaded();
      }
      return;
    }
    if (clickedButton === 'nacs') {
      if (!filter80Kw) return;
      const nextNacs = !nacsFilter;
      setNacsFilter(nextNacs);
      syncMapFiltersToUrl({
        filter80Kw: true,
        filter160Kw,
        cheapestFilter,
        carFilter,
        portFilter,
        onlineFilter,
        nacsFilter: nextNacs,
      });
      return;
    }
    let newPortFilter = portFilter;
    let newCarFilter = carFilter;
    let newOnlineFilter = onlineFilter;
    if (clickedButton === 'fast' || clickedButton === 'slow') {
      newPortFilter = portFilter === clickedButton ? 'all' : clickedButton;
      setPortFilter(newPortFilter);
    } else if (clickedButton === 'online') {
      newOnlineFilter = !onlineFilter;
      setOnlineFilter(newOnlineFilter);
    } else {
      newCarFilter = carFilter === clickedButton ? 'all' : clickedButton;
      setCarFilter(newCarFilter);
    }
    syncMapFiltersToUrl({
      filter80Kw,
      filter160Kw,
      cheapestFilter,
      carFilter: newCarFilter,
      portFilter: newPortFilter,
      onlineFilter: newOnlineFilter,
      nacsFilter,
    });
    const acdc = km220AcdcForMapFilters({
      filter80Kw,
      filter160KwActive,
      portFilter: newPortFilter,
    });
    const china = newCarFilter === 'all' ? 'all' : newCarFilter === 'china' ? 'china' : 'not_china';
    setIsFilterLoading(true);
    try {
      const loads = [fetchKm220Ports(acdc, newOnlineFilter, china)];
      if (filter80Kw) {
        loads.push(ensureEvuaStationsLoaded());
      } else {
        loads.push(fetchTokaPorts(acdc, newOnlineFilter, china));
      }
      await Promise.all(loads);
    } finally {
      setIsFilterLoading(false);
    }
  }

  const navigate = useNavigate();
  const { t } = useTranslation();
  const qrButtonRef = useRef(null);

  function useTokaCall() {
    const [fetchTokaApi] = api.useLazyGetTokaPortsQuery();
    const [tokaPorts, setTokaPorts] = useState();

    const fetchTokaPorts = async (acdc, freshOnly = false, chinaFilterValue = 'all') => {
      //       const { data } = await fetchTokaApi({ acdc, freshOnly, chinaFilter: chinaFilterValue });
      //       setTokaPorts(data);
    };

    return { tokaPorts, fetchTokaPorts };
  }

  const { tokaPorts, fetchTokaPorts } = useTokaCall();

  function useUgvCall() {
    const [fetchUgvApi] = api.useLazyGetUgvPortsQuery();
    const [ugvPorts, setUgvPorts] = useState();

    const fetchUgvPorts = async (acdc, freshOnly = false, chinaFilterValue = 'all') => {
      // Disabled UGV stations API call
      // const { data } = await fetchUgvApi({ acdc, freshOnly, chinaFilter: chinaFilterValue });
      // setUgvPorts(data);
    };

    return { ugvPorts, fetchUgvPorts };
  }

  const { ugvPorts, fetchUgvPorts } = useUgvCall();

  function useKm220Call() {
    const [fetchKm220Api] = api.useLazyGetKm220PortsQuery();
    const [km220Ports, setKm220Ports] = useState();

    const fetchKm220Ports = async (acdc, freshOnly = false, chinaFilterValue = 'all') => {
      try {
        const { data } = await fetchKm220Api({ acdc, freshOnly, chinaFilter: chinaFilterValue });
        // 429/errors return no data — still settle so the map loader cannot hang forever.
        if (Array.isArray(data)) {
          setKm220Ports(data);
        } else {
          setKm220Ports(prev => (Array.isArray(prev) ? prev : []));
        }
      } catch (error) {
        console.error('Error fetching KM220 ports:', error);
        setKm220Ports(prev => (Array.isArray(prev) ? prev : []));
      }
    };

    return { km220Ports, setKm220Ports, fetchKm220Ports };
  }

  const { km220Ports, setKm220Ports, fetchKm220Ports } = useKm220Call();

  function useEvuaStationsCall() {
    const [fetchEvuaApi, { isLoading: isEvuaLoading, isFetching: isEvuaFetching }] =
      api.useLazyGetEvua80KwStationsQuery();
    const [evuaPorts, setEvuaPorts] = useState([]);

    const fetchEvuaStations = async () => {
      try {
        const { data } = await fetchEvuaApi();
        setEvuaPorts(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error fetching EVUA stations:', error);
        setEvuaPorts([]);
      }
    };

    return { evuaPorts, fetchEvuaStations, isEvuaLoading, isEvuaFetching };
  }

  const { evuaPorts, fetchEvuaStations, isEvuaLoading, isEvuaFetching } = useEvuaStationsCall();

  async function ensureEvuaStationsLoaded() {
    if (evuaPorts.length > 0) return;
    setIsFilterLoading(true);
    try {
      await fetchEvuaStations();
    } finally {
      setIsFilterLoading(false);
    }
  }

  function syncMapFiltersToUrl(nextFilters) {
    const nextValue = buildMapFilterParam(nextFilters);
    const currentValue = searchParams.get('mapFilter') || null;
    if ((nextValue || null) === (currentValue || null)) return;
    skipNextUrlApplyRef.current = true;
    setSearchParams(withMapFilterSearchParams(searchParams, nextValue), { replace: true });
  }

  // URL → state for shared links and browser back/forward (before paint so LS cannot flash over URL).
  useLayoutEffect(() => {
    if (skipNextUrlApplyRef.current) {
      skipNextUrlApplyRef.current = false;
      return;
    }
    if (!urlMapFilters) return;
    setPortFilter(urlMapFilters.portFilter);
    setOnlineFilter(urlMapFilters.onlineFilter);
    setFilter80Kw(urlMapFilters.filter80Kw);
    setFilter160Kw(Boolean(urlMapFilters.filter80Kw && urlMapFilters.filter160Kw));
    setCheapestFilter(urlMapFilters.cheapestFilter);
    setCarFilter(urlMapFilters.carFilter);
    setNacsFilter(Boolean(urlMapFilters.nacsFilter));
  }, [mapFilterFromUrl, urlMapFilters, setFilter80Kw, setFilter160Kw, setCheapestFilter, setCarFilter]);

  useLayoutEffect(() => {
    const button = qrButtonRef.current;
    if (!button) return undefined;

    const placeQrBetweenZoomAndBottom = () => {
      const zoomOut = document.getElementById('mapZoomOut');
      const vv = window.visualViewport;
      const viewBottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
      // Capacitor Android WebView often reports 0 safe-area; keep clear of the gesture bar.
      const androidNav = document.body.classList.contains('capacitor-native-android') ? 32 : 0;
      const displayBottom = viewBottom - androidNav;
      const zoomBottom = zoomOut ? zoomOut.getBoundingClientRect().bottom : displayBottom * 0.72;
      const mid = (zoomBottom + displayBottom) / 2;
      button.style.top = `${Math.round(mid)}px`;
      button.style.bottom = 'auto';
      button.style.transform = 'translate(-50%, -50%)';
    };

    placeQrBetweenZoomAndBottom();
    const mapRoot = document.querySelector('#homePage .map-wrap');
    const observer = mapRoot
      ? new MutationObserver(() => {
          placeQrBetweenZoomAndBottom();
          if (document.getElementById('mapZoomOut')) {
            observer.disconnect();
          }
        })
      : null;
    observer?.observe(mapRoot, { childList: true, subtree: true });
    window.addEventListener('resize', placeQrBetweenZoomAndBottom);
    window.visualViewport?.addEventListener('resize', placeQrBetweenZoomAndBottom);
    window.visualViewport?.addEventListener('scroll', placeQrBetweenZoomAndBottom);

    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', placeQrBetweenZoomAndBottom);
      window.visualViewport?.removeEventListener('resize', placeQrBetweenZoomAndBottom);
      window.visualViewport?.removeEventListener('scroll', placeQrBetweenZoomAndBottom);
      button.style.top = '';
      button.style.bottom = '';
      button.style.transform = '';
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const preferRoaming = Boolean(urlMapFilters?.filter80Kw || urlMapFilters?.filter160Kw || filter80Kw);
    if (preferRoaming) {
      const roaming80 = true;
      const roaming160 = Boolean(urlMapFilters?.filter160Kw || (filter80Kw && filter160Kw));
      const roamingPortFilter = urlMapFilters?.portFilter ?? portFilter;
      const { acdc, chinaFilter: china, freshOnly } = getApiParams(roamingPortFilter, roaming80, roaming160);
      setIsFilterLoading(true);
      Promise.all([ensureEvuaStationsLoaded(), fetchKm220Ports(acdc, freshOnly, china)]).finally(() =>
        setIsFilterLoading(false)
      );
    } else {
      const { acdc, chinaFilter: china, freshOnly } = getApiParams();
      setIsFilterLoading(true);
      Promise.all([fetchTokaPorts(acdc, freshOnly, china), fetchKm220Ports(acdc, freshOnly, china)]).finally(() =>
        setIsFilterLoading(false)
      );
    }
    // Drop the overlay if station/all hangs (iptables DROP / no fetch timeout).
    const hangWatchdog = window.setTimeout(() => {
      setKm220Ports(prev => (prev === undefined ? [] : prev));
      setIsFilterLoading(false);
    }, 12_000);
    return () => window.clearTimeout(hangWatchdog);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // + Roaming: EV UA (AC+DC) + 220-km. Slow/Fast stay visible and filter both. 160+ is a sub-chip.
  const showEvuaOnMap = Boolean(filter80Kw);
  const showKm220OnMap = !isEvuaExclusiveMapMode(filter80Kw, cheapestFilter, filter160KwActive);

  const evuaPortsToShow = useMemo(
    () =>
      showEvuaOnMap
        ? filterEvuaPortsForMap(evuaPorts, {
            filter80Kw,
            filter160Kw: filter160KwActive,
            cheapestFilter,
            carFilter,
            portFilter,
            nacsFilter,
          })
        : [],
    [showEvuaOnMap, evuaPorts, filter80Kw, filter160KwActive, cheapestFilter, carFilter, portFilter, nacsFilter]
  );

  const km220PortsToShow = useMemo(
    () =>
      filterKm220PortsForMap(km220Ports, {
        filter80Kw,
        filter160KwActive,
        cheapestFilter,
        portFilter,
        nacsFilter,
      }),
    [km220Ports, cheapestFilter, filter80Kw, filter160KwActive, portFilter, nacsFilter]
  );

  const isEvuaPortsLoading =
    Boolean(filter80Kw) && (isEvuaLoading || isEvuaFetching || (evuaPorts.length === 0 && isFilterLoading));

  function showMap() {
    // EV UA loading is shown on the + Roaming chip only — do not dim the whole map.
    const isLoadingPorts = showKm220OnMap && km220Ports === undefined;
    // Toka/UGV stay off + Roaming; 220-km stays on (except + Roaming + Cheapest).
    const showLegacyRoamingPorts = !showEvuaOnMap;
    return (
      <Map
        tokaPorts={showLegacyRoamingPorts ? tokaPorts : []}
        ugvPorts={showLegacyRoamingPorts ? ugvPorts : []}
        km220Ports={showKm220OnMap ? km220PortsToShow : []}
        km220MatchPorts={showEvuaOnMap && showKm220OnMap ? km220PortsToShow : []}
        evuaPorts={evuaPortsToShow}
        evuaStationCatalog={evuaPorts}
        minPowerKw={filter160KwActive ? MAP_FILTER_160_KW : 0}
        portFilter={portFilter}
        isLoading={isLoadingPorts}
      />
    );
  }

  return (
    <>
      <SeoHead fallbackTitle="220 km">
        {/* Primary Meta Tags */}
        <title>{seoConfig.title}</title>
        <meta name="title" content={seoConfig.title} />
        <meta name="description" content={seoConfig.description} />
        <meta name="keywords" content={seoConfig.keywords} />
        <link rel="canonical" href={seoConfig.url} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seoConfig.url} />
        <meta property="og:title" content={seoConfig.title} />
        <meta property="og:description" content={seoConfig.description} />
        <meta property="og:image" content={seoConfig.image} />
        <meta property="og:site_name" content="Мережа 220 км" />
        <meta property="og:locale" content="uk_UA" />
        <meta property="og:locale:alternate" content="ru_RU" />
        <meta property="og:locale:alternate" content="en_US" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={seoConfig.url} />
        <meta property="twitter:title" content={seoConfig.title} />
        <meta property="twitter:description" content={seoConfig.description} />
        <meta property="twitter:image" content={seoConfig.image} />

        {/* Additional SEO tags */}
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="author" content="Мережа 220 км" />
        <meta name="geo.region" content="UA" />
        <meta name="geo.placename" content="Ukraine" />

        {/* hreflang tags */}
        <link rel="alternate" hrefLang="uk" href="https://220-km.com/" />
        <link rel="alternate" hrefLang="ru" href="https://220-km.com/?lang=ru" />
        <link rel="alternate" hrefLang="en" href="https://220-km.com/?lang=en" />
        <link rel="alternate" hrefLang="x-default" href="https://220-km.com/" />

        {/* Structured Data */}
        <script type="application/ld+json">{JSON.stringify(seoConfig.structuredData)}</script>
        <script type="application/ld+json">{JSON.stringify(seoConfig.websiteStructuredData)}</script>
        <script type="application/ld+json">{JSON.stringify(seoConfig.serviceStructuredData)}</script>
        <script type="application/ld+json">{JSON.stringify(seoConfig.faqStructuredData)}</script>
        <script type="application/ld+json">{JSON.stringify(seoConfig.openEmsSoftwareStructuredData)}</script>
        <script type="application/ld+json">{JSON.stringify(seoConfig.iedNasResearchArticleStructuredData)}</script>
      </SeoHead>
      <div id="homePage">
        {showMap()}
        <button
          ref={qrButtonRef}
          type="button"
          onClick={() => {
            navigate('/scanner');
          }}
          className="qr-button"
        >
          <SVGBanner />
          <span>{t('qrScanner.nameButton')}</span>
        </button>
        <div className="map-filters-panel">
          <div className="map-filters-panel-inner">
            {(filter80Kw
              ? ['slow', 'fast', '80kw', '160kw', 'nacs', 'china', 'cheapest']
              : ['slow', 'fast', '80kw', 'china', 'cheapest', 'online']
            ).map(key => {
              const isActive =
                key === '80kw'
                  ? filter80Kw
                  : key === 'nacs'
                    ? nacsFilter
                    : key === '160kw'
                      ? filter160Kw
                      : key === 'fast' || key === 'slow'
                        ? portFilter === key
                        : key === 'online'
                          ? onlineFilter
                          : key === 'cheapest'
                            ? cheapestFilter
                            : carFilter === key;
              const label =
                key === '80kw'
                  ? t('filter80Kw')
                  : key === '160kw'
                    ? t('filter160Kw')
                    : key === 'online'
                      ? t('єСвітло')
                      : key === 'cheapest'
                        ? t('filterCheapest')
                        : t(`filter${key.charAt(0).toUpperCase() + key.slice(1)}`);
              const isRoamingChipLoading = key === '80kw' && isEvuaPortsLoading;
              return (
                <div
                  key={key}
                  role="button"
                  tabIndex={0}
                  className={[
                    'map-filter-row',
                    isActive ? 'map-filter-row-active' : '',
                    isRoamingChipLoading ? 'map-filter-row-loading' : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  aria-busy={isRoamingChipLoading || undefined}
                  onClick={() => applyMapFilter(key)}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      applyMapFilter(key);
                    }
                  }}
                >
                  {isRoamingChipLoading ? <span className="map-filter-row-spinner" aria-hidden /> : null}
                  <span>{label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
